/**
* Safe Swym Cart Integration
* Safely updates cart counter for Swym wishlist without interfering with existing functionality
*/

(function() {
  'use strict';

  let isUpdating = false;
  let lastCartCount = 0;

  // Safe update cart counter function
  function safeUpdateCartCounter() {
    if (isUpdating) return;
    isUpdating = true;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Only update if count actually changed
        if (cart.item_count !== lastCartCount) {
          lastCartCount = cart.item_count;

          // Update only CART counter elements (not wishlist)
          const cartCountElements = document.querySelectorAll('.thb-item-count');
          cartCountElements.forEach(element => {
            // Check if this is a cart counter (not wishlist counter)
            const isCartCounter = element.closest('a[href*="cart"]') || 
                                element.closest('#cart-drawer-toggle') ||
                                element.closest('.thb-secondary-cart') ||
                                element.closest('[href*="cart"]');

            // Only update cart counters, not wishlist counters
            if (isCartCounter && element.offsetParent !== null) {
              if (cart.item_count > 99) {
                element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
              } else {
                element.textContent = cart.item_count;
              }
            }
          });

          console.log('Safe cart counter updated:', cart.item_count);
        }
        isUpdating = false;
      })
      .catch(error => {
        console.error('Error safe updating cart counter:', error);
        isUpdating = false;
      });
  }

  // Simple click listener for Swym add to cart buttons
  function setupSwymListener() {
    document.addEventListener('click', function(event) {
      const target = event.target;

      // Only listen for Swym add to cart buttons
      if (target.classList.contains('swym-button') && 
          target.textContent && target.textContent.includes('ADDED TO BAG')) {

        console.log('Swym add to cart button clicked');
        // Wait for the request to complete, then update counter
        setTimeout(safeUpdateCartCounter, 200);
        setTimeout(safeUpdateCartCounter, 500);
        setTimeout(safeUpdateCartCounter, 800);
      }
    });
  }

  // Intercept cart add requests for faster response
  function setupCartInterception() {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url] = args;

      if (typeof url === 'string' && url.includes('/cart/add.js')) {
        return originalFetch.apply(this, args).then(response => {
          if (response.ok) {
            // Update immediately when cart add is successful
            setTimeout(safeUpdateCartCounter, 100);
            setTimeout(safeUpdateCartCounter, 300);
          }
          return response;
        });
      }

      return originalFetch.apply(this, args);
    };

    // jQuery AJAX fallback
    if (window.jQuery) {
      $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && settings.url.includes('/cart/add.js') && xhr.status === 200) {
          setTimeout(safeUpdateCartCounter, 100);
          setTimeout(safeUpdateCartCounter, 300);
        }
      });
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Safe Swym Cart Integration initialized');

    // Get initial cart count
    safeUpdateCartCounter();

    // Setup cart interception for faster response
    setupCartInterception();

    // Setup simple listener
    setupSwymListener();

    // Light periodic check as fallback (every 3 seconds)
    setInterval(safeUpdateCartCounter, 3000);
  });

  // Expose update function globally for manual calls
  window.safeUpdateCartCounter = safeUpdateCartCounter;
})();
